import styled from 'styled-components';

export const Container = styled.div`
    ul {
        li .content{
            background-color: white;
            text-align: center;
            align-items: center;
        }

        li {
            margin: 0 10px;
        }

        li:last-child{
            margin: 10px 10px;
        }
    }

    section {
        padding: 0;
    }
`;

export const FunnelDiv = styled.div`
    @media print  
    {
        page-break-inside: avoid;
    }

    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    padding: 0 0 30px 0;

    .funnel-chart {
        padding-left: 30px;
    }
`;

export const Title = styled.span`
    font-size: 25px;
    font-weight: 500;
    color: ${({ color }) => color};
`;

export const WTitle = styled.h2`
    font-size: 15px;
    font-weight: 500;
    margin-top: 30px;
`;

export const WText = styled.h2`
    font-size: 14px;
    font-weight: 400;
    margin-top: 10px;
`;
